export interface ComicChapter {
  id: string;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  status: '连载中' | '已完结';
  chapters: ComicChapter[];
  totalChapters: number;
  views: number;
  rating: number;
  updateDate: string;
  tags: string[];
}

export const comics: Comic[] = [
  {
    id: 'comic-1',
    title: '暗夜女神的契约',
    author: '星野琉璃',
    category: '韩漫',
    categorySlug: 'korean',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20cover%20art%2C%20elegant%20female%20protagonist%20with%20long%20dark%20hair%20and%20mysterious%20eyes%2C%20dark%20fantasy%20theme%2C%20moonlight%20illumination%2C%20soft%20romantic%20vibe%2C%20clean%20white%20background%20with%20subtle%20sparkles%2C%20minimalist%20composition%2C%20warm%20color%20palette%20with%20deep%20red%20accents%2C%20professional%20illustration%20style&width=400&height=560&seq=manga-cover-01&orientation=portrait',
    description: '在一个被黑暗势力笼罩的世界里，拥有神秘力量的少女艾琳与冷酷的暗夜骑士签订了契约。为了拯救被诅咒的王国，她必须在光明与黑暗之间做出选择，而这段契约背后隐藏着一个足以改变世界的秘密……',
    status: '连载中',
    chapters: [
      { id: 'ch-1-1', title: '第1话 命运的相遇', updateDate: '2026-08-01' },
      { id: 'ch-1-2', title: '第2话 契约之夜', updateDate: '2026-07-28' },
      { id: 'ch-1-3', title: '第3话 暗夜骑士', updateDate: '2026-07-25' },
      { id: 'ch-1-4', title: '第4话 隐藏的真相', updateDate: '2026-07-22' },
      { id: 'ch-1-5', title: '第5话 光之试炼', updateDate: '2026-07-19' },
    ],
    totalChapters: 48,
    views: 1285000,
    rating: 4.8,
    updateDate: '2026-08-01',
    tags: ['奇幻', '恋爱', '战斗'],
  },
  {
    id: 'comic-2',
    title: '甜蜜陷阱',
    author: '韩智雅',
    category: '韩漫',
    categorySlug: 'korean',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20manhwa%20cover%20art%2C%20young%20couple%20with%20warm%20smiles%2C%20cherry%20blossom%20petals%20floating%2C%20pastel%20pink%20and%20cream%20color%20scheme%2C%20clean%20simple%20background%2C%20soft%20lighting%2C%20romantic%20atmosphere%2C%20modern%20school%20setting%2C%20korean%20webtoon%20style%20illustration&width=400&height=560&seq=manga-cover-02&orientation=portrait',
    description: '平凡女高中生林小夏意外收到了校草学长的告白，原本以为是甜蜜恋情的开始，却发现这一切都是一个精心设计的陷阱。当真相一步步揭开，她该如何面对这场以爱为名的骗局？',
    status: '连载中',
    chapters: [
      { id: 'ch-2-1', title: '第1话 意外的告白', updateDate: '2026-08-02' },
      { id: 'ch-2-2', title: '第2话 学长的秘密', updateDate: '2026-07-30' },
      { id: 'ch-2-3', title: '第3话 甜蜜的谎言', updateDate: '2026-07-27' },
    ],
    totalChapters: 36,
    views: 956000,
    rating: 4.6,
    updateDate: '2026-08-02',
    tags: ['恋爱', '校园', '悬疑'],
  },
  {
    id: 'comic-3',
    title: '剑圣重生',
    author: '武田信玄',
    category: '日漫',
    categorySlug: 'japanese',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dynamic%20Japanese%20manga%20cover%20art%2C%20powerful%20swordsman%20in%20traditional%20samurai%20armor%20with%20flowing%20cape%2C%20holding%20a%20glowing%20katana%2C%20dramatic%20wind%20effect%2C%20warm%20golden%20sunset%20tones%2C%20clean%20white%20background%20with%20subtle%20energy%20waves%2C%20epic%20fantasy%20atmosphere%2C%20professional%20anime%20style&width=400&height=560&seq=manga-cover-03&orientation=portrait',
    description: '一代剑圣在最终决战中陨落，却意外重生回到少年时代。带着前世的记忆和战斗经验，他决定改写命运，守护曾经失去的一切。这一次，他将踏上一条不同的剑道之路！',
    status: '已完结',
    chapters: [
      { id: 'ch-3-1', title: '第1话 陨落之刻', updateDate: '2026-06-15' },
      { id: 'ch-3-2', title: '第2话 重返少年', updateDate: '2026-06-12' },
      { id: 'ch-3-3', title: '第3话 新的开始', updateDate: '2026-06-09' },
      { id: 'ch-3-4', title: '第4话 宿命对决', updateDate: '2026-06-06' },
    ],
    totalChapters: 120,
    views: 2350000,
    rating: 4.9,
    updateDate: '2026-06-15',
    tags: ['热血', '奇幻', '战斗', '重生'],
  },
  {
    id: 'comic-4',
    title: '星河帝国',
    author: '林墨',
    category: '国漫',
    categorySlug: 'chinese',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20Chinese%20manhua%20cover%20art%2C%20young%20male%20commander%20in%20sleek%20spacesuit%2C%20starship%20bridge%20background%2C%20glowing%20holographic%20displays%2C%20deep%20space%20with%20nebula%20colors%2C%20clean%20minimalist%20composition%2C%20warm%20coral%20and%20teal%20color%20scheme%2C%20professional%20illustration%20style&width=400&height=560&seq=manga-cover-04&orientation=portrait',
    description: '公元3024年，人类已经建立了横跨银河系的庞大帝国。年轻的指挥官陆辰在边境巡逻时发现了来自未知文明的神秘信号，一场关乎人类命运的星际战争即将拉开帷幕。',
    status: '连载中',
    chapters: [
      { id: 'ch-4-1', title: '第1话 边境信号', updateDate: '2026-08-03' },
      { id: 'ch-4-2', title: '第2话 未知文明', updateDate: '2026-07-31' },
      { id: 'ch-4-3', title: '第3话 星际舰队', updateDate: '2026-07-28' },
    ],
    totalChapters: 52,
    views: 789000,
    rating: 4.5,
    updateDate: '2026-08-03',
    tags: ['科幻', '冒险', '机甲'],
  },
  {
    id: 'comic-5',
    title: '恶魔执事',
    author: '尹素媛',
    category: '韩漫',
    categorySlug: 'korean',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20elegant%20manhwa%20cover%20art%2C%20handsome%20butler%20in%20black%20suit%20with%20mysterious%20red%20eyes%2C%20gothic%20mansion%20atmosphere%2C%20deep%20burgundy%20and%20gold%20accents%2C%20clean%20dark%20background%20with%20candlelight%20glow%2C%20supernatural%20romance%20theme%2C%20professional%20Korean%20webtoon%20style&width=400&height=560&seq=manga-cover-05&orientation=portrait',
    description: '落魄贵族千金安吉尔为了拯救家族，不得不与一位神秘英俊的恶魔执事签订契约。然而随着相处的时间越来越长，她发现这个恶魔执事背后似乎藏着更深的目的……',
    status: '连载中',
    chapters: [
      { id: 'ch-5-1', title: '第1话 破落贵族', updateDate: '2026-08-01' },
      { id: 'ch-5-2', title: '第2话 恶魔的契约', updateDate: '2026-07-29' },
      { id: 'ch-5-3', title: '第3话 危险的诱惑', updateDate: '2026-07-26' },
    ],
    totalChapters: 28,
    views: 1102000,
    rating: 4.7,
    updateDate: '2026-08-01',
    tags: ['奇幻', '恋爱', '悬疑'],
  },
  {
    id: 'comic-6',
    title: '东京除灵师',
    author: '山本一郎',
    category: '日漫',
    categorySlug: 'japanese',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20supernatural%20Japanese%20manga%20cover%2C%20teenage%20exorcist%20with%20spiritual%20energy%20surrounding%20hands%2C%20modern%20Tokyo%20cityscape%20at%20night%20in%20background%2C%20ghostly%20figures%20in%20shadows%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20clean%20composition%2C%20professional%20anime%20illustration%20style&width=400&height=560&seq=manga-cover-06&orientation=portrait',
    description: '普通高中生清水翔太天生拥有看见灵体的能力，一直被当作怪人。直到遇见了一位神秘的美少女除灵师，他才知道自己的能力是被称为"天眼"的稀有才能。从此，他踏上了守护东京的除灵之路。',
    status: '连载中',
    chapters: [
      { id: 'ch-6-1', title: '第1话 能看见的少年', updateDate: '2026-07-31' },
      { id: 'ch-6-2', title: '第2话 除灵师登场', updateDate: '2026-07-28' },
      { id: 'ch-6-3', title: '第3话 第一个任务', updateDate: '2026-07-25' },
    ],
    totalChapters: 42,
    views: 876000,
    rating: 4.4,
    updateDate: '2026-07-31',
    tags: ['热血', '奇幻', '校园'],
  },
  {
    id: 'comic-7',
    title: '武林至尊',
    author: '张雷',
    category: '国漫',
    categorySlug: 'chinese',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Chinese%20manhua%20cover%20art%2C%20powerful%20warrior%20in%20flowing%20traditional%20hanfu%20robes%2C%20ancient%20Chinese%20mountain%20landscape%20with%20mist%2C%20dragon%20silhouette%20in%20clouds%2C%20warm%20golden%20and%20jade%20green%20color%20palette%2C%20clean%20minimalist%20background%2C%20epic%20wuxia%20atmosphere%2C%20professional%20illustration&width=400&height=560&seq=manga-cover-07&orientation=portrait',
    description: '少年秦风出身平凡的武馆，却怀揣着成为武林至尊的梦想。在一次意外中获得上古神功传承后，他踏上了一条充满挑战的武道修行之路。各大门派、神秘组织、千年恩怨，都将在这场江湖风暴中揭晓。',
    status: '连载中',
    chapters: [
      { id: 'ch-7-1', title: '第1话 少年秦风', updateDate: '2026-08-02' },
      { id: 'ch-7-2', title: '第2话 神功初现', updateDate: '2026-07-30' },
      { id: 'ch-7-3', title: '第3话 江湖风云', updateDate: '2026-07-27' },
    ],
    totalChapters: 64,
    views: 1560000,
    rating: 4.7,
    updateDate: '2026-08-02',
    tags: ['武侠', '热血', '冒险'],
  },
  {
    id: 'comic-8',
    title: '月光下的你',
    author: '朴彩英',
    category: '韩漫',
    categorySlug: 'korean',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dreamy%20romantic%20manhwa%20cover%2C%20young%20couple%20standing%20under%20moonlight%20on%20a%20rooftop%2C%20starry%20night%20sky%2C%20soft%20pastel%20colors%20with%20lavender%20and%20cream%20tones%2C%20clean%20simple%20composition%2C%20warm%20atmosphere%2C%20gentle%20romantic%20vibe%2C%20Korean%20webtoon%20illustration%20style&width=400&height=560&seq=manga-cover-08&orientation=portrait',
    description: '音乐系才女金多妍在学校的屋顶上偶遇了独自弹吉他的神秘学长。每个月光皎洁的夜晚，他们都会在屋顶上相遇，音乐和爱情在这片小小的天地里悄然生长。',
    status: '已完结',
    chapters: [
      { id: 'ch-8-1', title: '第1话 屋顶的旋律', updateDate: '2026-05-20' },
      { id: 'ch-8-2', title: '第2话 月光下的约定', updateDate: '2026-05-17' },
      { id: 'ch-8-3', title: '第3话 心的和弦', updateDate: '2026-05-14' },
    ],
    totalChapters: 24,
    views: 689000,
    rating: 4.9,
    updateDate: '2026-05-20',
    tags: ['恋爱', '校园', '音乐'],
  },
  {
    id: 'comic-9',
    title: '异世界美食家',
    author: '田中花子',
    category: '日漫',
    categorySlug: 'japanese',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20whimsical%20Japanese%20manga%20cover%2C%20cheerful%20chef%20holding%20a%20magical%20sparkling%20dish%2C%20fantasy%20world%20with%20floating%20ingredients%2C%20warm%20golden%20and%20cream%20color%20scheme%2C%20clean%20minimalist%20composition%2C%20cozy%20atmosphere%2C%20food%20themed%20isekai%20adventure%2C%20professional%20anime%20illustration&width=400&height=560&seq=manga-cover-09&orientation=portrait',
    description: '倒霉的上班族佐藤健在加班猝死后，竟然穿越到了一个没有美食概念的异世界！凭借前世的料理知识，他决定在这个世界掀起一场美食革命，让异世界居民也体验到舌尖上的幸福。',
    status: '连载中',
    chapters: [
      { id: 'ch-9-1', title: '第1话 加班猝死', updateDate: '2026-08-01' },
      { id: 'ch-9-2', title: '第2话 没有味道的世界', updateDate: '2026-07-29' },
      { id: 'ch-9-3', title: '第3话 第一顿料理', updateDate: '2026-07-26' },
    ],
    totalChapters: 38,
    views: 923000,
    rating: 4.6,
    updateDate: '2026-08-01',
    tags: ['美食', '奇幻', '搞笑', '异世界'],
  },
  {
    id: 'comic-10',
    title: '凤舞九天',
    author: '柳如烟',
    category: '国漫',
    categorySlug: 'chinese',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20gorgeous%20Chinese%20manhua%20cover%2C%20elegant%20female%20warrior%20in%20flowing%20red%20hanfu%20with%20phoenix%20motif%2C%20ancient%20palace%20background%20with%20cherry%20blossoms%2C%20warm%20coral%20and%20gold%20color%20palette%2C%20clean%20composition%2C%20empowered%20heroine%2C%20professional%20Chinese%20illustration%20style&width=400&height=560&seq=manga-cover-10&orientation=portrait',
    description: '将军之女凤清歌在家族被灭门后，隐姓埋名进入皇宫为婢。她凭借过人的智慧和武艺，在尔虞我诈的宫廷中步步为营，只为有朝一日为家族洗雪冤屈，让真相大白于天下。',
    status: '连载中',
    chapters: [
      { id: 'ch-10-1', title: '第1话 灭门之祸', updateDate: '2026-08-03' },
      { id: 'ch-10-2', title: '第2话 入宫为婢', updateDate: '2026-07-31' },
      { id: 'ch-10-3', title: '第3话 深宫暗流', updateDate: '2026-07-28' },
    ],
    totalChapters: 56,
    views: 1340000,
    rating: 4.8,
    updateDate: '2026-08-03',
    tags: ['古风', '权谋', '恋爱'],
  },
  {
    id: 'comic-11',
    title: '深渊觉醒',
    author: '金秀贤',
    category: '韩漫',
    categorySlug: 'korean',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20thriller%20manhwa%20cover%2C%20mysterious%20figure%20with%20glowing%20eyes%20emerging%20from%20shadows%2C%20abstract%20geometric%20patterns%2C%20deep%20burgundy%20and%20charcoal%20color%20scheme%2C%20clean%20minimalist%20composition%2C%20psychological%20horror%20atmosphere%2C%20professional%20Korean%20webtoon%20style&width=400&height=560&seq=manga-cover-11&orientation=portrait',
    description: '心理医生李贤宇接手了一位声称能看到他人内心黑暗面的特殊病人。随着治疗的深入，他发现这位病人的"幻觉"似乎不仅仅是幻觉那么简单。当他自己也开始看到那些黑暗面时，真相的深渊正在慢慢吞噬他。',
    status: '连载中',
    chapters: [
      { id: 'ch-11-1', title: '第1话 特殊的病人', updateDate: '2026-07-30' },
      { id: 'ch-11-2', title: '第2话 黑暗的视野', updateDate: '2026-07-27' },
      { id: 'ch-11-3', title: '第3话 不可言说', updateDate: '2026-07-24' },
    ],
    totalChapters: 32,
    views: 567000,
    rating: 4.3,
    updateDate: '2026-07-30',
    tags: ['悬疑', '惊悚', '心理'],
  },
  {
    id: 'comic-12',
    title: '偶像练习生',
    author: '樱井美咲',
    category: '日漫',
    categorySlug: 'japanese',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Japanese%20manga%20cover%2C%20aspiring%20idol%20group%20of%20young%20performers%20on%20stage%20with%20sparkling%20lights%2C%20energetic%20atmosphere%2C%20pastel%20pink%20and%20mint%20green%20color%20scheme%2C%20clean%20composition%2C%20youthful%20dream-chasing%20theme%2C%20professional%20anime%20illustration&width=400&height=560&seq=manga-cover-12&orientation=portrait',
    description: '普通高中生星野遥在街上被星探发掘，加入了顶级娱乐公司的偶像练习生计划。在这里，她将与来自全国各地的天才少女们一起竞争出道名额，追逐舞台梦想！',
    status: '连载中',
    chapters: [
      { id: 'ch-12-1', title: '第1话 命运的星探', updateDate: '2026-08-01' },
      { id: 'ch-12-2', title: '第2话 练习生宿舍', updateDate: '2026-07-29' },
      { id: 'ch-12-3', title: '第3话 第一次考核', updateDate: '2026-07-26' },
    ],
    totalChapters: 30,
    views: 1120000,
    rating: 4.5,
    updateDate: '2026-08-01',
    tags: ['偶像', '校园', '励志'],
  },
];

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '韩漫', slug: 'korean' },
  { name: '日漫', slug: 'japanese' },
  { name: '国漫', slug: 'chinese' },
  { name: '热血', slug: 'action' },
  { name: '恋爱', slug: 'romance' },
  { name: '奇幻', slug: 'fantasy' },
  { name: '悬疑', slug: 'mystery' },
];